export default "__VITE_ASSET__ff8dd52d__"